import React, { useState, useCallback } from 'react'
import { withRouter, Link } from 'react-router-dom'
import toastr from 'toastr'
import 'toastr/build/toastr.min.css'
import moment from 'moment'
import 'moment/min/locales'
import { isEmpty, head, filter } from 'lodash'

import ApiService from '../../../data/services/ApiService'
import DefaultImage from '../../../assets/images/avatar-product-placeholder.png'
import PagingState from '../../../components/PagingState'
import { getProductPrimaryImageUrl } from '../../../helpers/ProductMedia'

import debounce from 'lodash.debounce'
import useProductsData from '../../../hooks/useProductsData'

import {
    Row,
    Col,
    Input,
    Card,
    CardBody,
    Table
} from 'reactstrap'

moment.locale('es')

const Datatable = () => {
    const [rowsPerPage, setRowsPerPage] = useState(20)
    const {
        filteredData,
        totalCount,
        offset,
        changePage,
        remoteSearch,
        fetchProducts
    } = useProductsData(rowsPerPage)

    const [inputValue, setInputValue] = useState("")

    const debouncedSearch = useCallback(
        debounce((value) => {
            remoteSearch(value)
        }, 300),
        [remoteSearch]
    )

    const onSearchChange = (e) => {
        const value = e.target.value

        setInputValue(value)
        debouncedSearch(value)
    }

    const showToast = (title, message, toastType) => {
        if (toastType === "info") toastr.info(message, title)
        else if (toastType === "warning") toastr.warning(message, title)
        else if (toastType === "error") toastr.error(message, title)
        else toastr.success(message, title)
    }

    const _deleteItem = async (id) => {
        try {
            const result = await ApiService.deleteProduct(id)

            if (!result.data.success) {
                showToast('Error', 'Hubo un problema al eliminar el producto', 'error')
            } else {
                showToast('¡Éxito!', 'Producto eliminado correctamente', 'success')
            }

            // Refetch para refrescar tabla
            await fetchProducts()
        } catch (error) {
            console.log(error)
            showToast('Error', 'Hubo un problema al eliminar el producto', 'error')
        }
    }

    return (
        <React.Fragment>
            <Card>
                <CardBody>
                    <Row className="mb-2">
                        <Col sm="4">
                            <div className="search-box mr-2 mb-2 d-inline-block">
                                <div className="position-relative">
                                    <Input
                                        type="text"
                                        value={inputValue}
                                        className="form-control"
                                        placeholder="Buscar"
                                        onChange={onSearchChange}
                                    />
                                    <i className="bx bx-search-alt search-icon"></i>
                                </div>
                            </div>
                        </Col>

                        <Col sm="8">
                            <div className="text-sm-right">
                                <Link
                                    to={`/products/bulk`}
                                    className="btn btn-default btn-rounded mb-2 mr-2"
                                >
                                    <i className="mdi mdi-table-edit mr-1"></i> Actualización masiva
                                </Link>

                                <Link to="/products/add" className="btn btn-default btn-rounded mb-2 mr-2">
                                    <i className="mdi mdi-plus mr-1"></i> Agregar Producto
                                </Link>
                            </div>
                        </Col>
                    </Row>
                </CardBody>
            </Card>

            <Row>
                <Card>
                    <div className="table-responsive">
                        <Table striped className="align-middle">
                            <thead className="table-light">
                                <tr>
                                    <th>Imagen</th>
                                    <th>Nombre de Producto</th>
                                    <th>Categoría</th>
                                    <th>Marca</th>
                                    <th># Variantes</th>
                                    <th>...</th>
                                </tr>
                            </thead>

                            <tbody>
                                {filteredData.length === 0 && (
                                    <tr>
                                        <td colSpan="5" className="text-center py-4 text-muted">
                                            No se encontraron productos.
                                        </td>
                                    </tr>
                                )}

                                {filteredData && filteredData.map((item, key) => {
                                    const imageUrl = getProductPrimaryImageUrl(item, DefaultImage)
                                    
                                    return (
                                    <tr key={key}>
                                        <td>
                                            <img 
                                                style={{ maxWidth: '128px' }}
                                                src={imageUrl}
                                                alt="" />
                                        </td>

                                        <td>{item.name} <small>(SKU: {item.sku})</small></td>
                                        <td>{item.category.name} {`>`} {item.subcategory.name}</td>
                                        <td>{item.brand.name}</td>
                                        <td>{item.variants.length}</td>

                                        <td>
                                            <div className="d-flex gap-2">
                                                <Link to={`/products/edit/${item.id}`}>
                                                    <i className="mdi mdi-pencil"></i>
                                                </Link>

                                                <Link
                                                    to={`#`}
                                                    onClick={(e) => {
                                                        e.preventDefault()
                                                        _deleteItem(item.id)
                                                    }}
                                                >
                                                    <i className="mdi mdi-trash-can font-size-16 mr-2"></i>
                                                </Link>
                                            </div>
                                        </td>
                                    </tr>
                                )})
                                }
                            </tbody>
                        </Table>
                    </div>
                </Card>
            </Row>

            <Card>
                <PagingState
                    onPageChange={changePage}
                    currentPage={Math.floor(offset / rowsPerPage)}
                    pageSize={rowsPerPage}
                    totalCount={totalCount}
                    maxVisiblePages={6}
                    handleRowsPerPageChange={(e) => {
                        e.preventDefault()
                        setRowsPerPage(Number(e.target.value))
                    }}
                />
            </Card>
        </React.Fragment>
    )
}

export default withRouter(Datatable)
